export { default } from './LegalNotice';
